export default __webpack_public_path__ + "static/media/line-spacing.5962575d.svg";